var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCvv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.006,
    height: 50.021,
    viewBox: "0 0 50.006 50.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 25.003,
    cy: 25.003,
    r: 25.003,
    transform: "translate(0 0.015)",
    fill: "gray"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "?",
    transform: "translate(16.81 37)",
    fill: "#fff",
    fontSize: 34.094,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                    ?\n                  "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCvv);
export default __webpack_public_path__ + "static/media/iconCvv.217678279e0aa1e958f43fa7a651b6b0.svg";
export { ForwardRef as ReactComponent };